import { getSpeedLabel } from './getSpeedInfo';
export default getSpeedLabel;
